module.exports = __webpack_public_path__ + "static/img/logo.fb0a1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/f_home/logo.png
// module id = Yekt
// module chunks = 10